var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SelectionInfo.scss';
import { Button } from 'antd';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getClosestButton } from '@lib/popups';
import React from 'react';
import { Else, If, Then, When } from 'react-if';
import { SonarAlert } from '@ui/SonarAlert';
export const SelectionInfo = (_a) => {
    var { active, bordered, id, onEdit, onSelectAll, selectedCount, selectionType = COPY_SPECIFIC.ITEMS, totalCount } = _a, otherProps = __rest(_a, ["active", "bordered", "id", "onEdit", "onSelectAll", "selectedCount", "selectionType", "totalCount"]);
    const allSelected = selectedCount === totalCount;
    const noneSelected = selectedCount === 0;
    const allText = allSelected ? `${COPY_SPECIFIC.ALL} ` : '';
    const selectedText = `${allText}${selectedCount} ${selectionType} ${COPY_SPECIFIC.SELECTED}`;
    const editText = `${COPY_SPECIFIC.EDIT} ${allText}${selectedCount} ${selectionType}`;
    const selectAllButtonText = `${COPY_SPECIFIC.SELECT_ALL} ${totalCount} ${selectionType}`;
    const selectionInfoMessage = () => React.createElement(React.Fragment, null,
        React.createElement(If, { condition: Boolean(onEdit) },
            React.createElement(Then, null,
                React.createElement(Button, { onClick: (e) => onEdit && onEdit(getClosestButton(e.target)), type: 'primary' }, editText)),
            React.createElement(Else, null, noneSelected ? selectionType : selectedText)),
        React.createElement(When, { condition: !noneSelected && !allSelected },
            React.createElement(Button, { id: `${id}-select-all-button`, onClick: onSelectAll, size: 'small', type: 'link' }, selectAllButtonText)));
    return (React.createElement(SonarAlert, Object.assign({ active: active, className: classNames('selection-info', { bordered }), closable: true, closeIcon: React.createElement("span", { className: 'anticon anticon-close' }, COPY_SPECIFIC.CLEAR_SELECTION), message: selectionInfoMessage(), type: 'info' }, otherProps)));
};
